module.exports = __webpack_public_path__ + "static/media/docker.2103c445.png";